import React from 'react';
import {
    ParticlesJsDiv
} from './styledComponents';

const Pure = () => <ParticlesJsDiv id="particles-js" />

export default Pure;
